/**
 * Converts quantity from primary to secondary
 * @param {number} quantity - quantity to convert
 * @param {Object} options - conversion options
 *
 * @return {number} converted - converted quantity
 */
const primaryToSecondary = (quantity, options) => {
    let converted;
    let rounded;
    let division;

    division = reduceTail(quantity / options.unitConversionRate);

    //division may be < 0.5 and will be rounded to 0 with Math.round().
    //unit can't be 0, set division to 1 (min unit)
    if (division < 0.5) {
        division = 1;
    }

    rounded = Math.round(division);

    converted = reduceTail(rounded);

    return converted;
};

/**
 * Converts quantity from secondary to primary
 * @param {number} quantity - quantity to convert
 * @param {Object} options - conversion options
 *
 * @return {number} - converted quantity
 */
const secondaryToPrimary = (quantity, options) => {
    return reduceTail(quantity * options.unitConversionRate);
};

/**
 * Rounds quantity to closest step multiple
 * @param {number} quantity - quantity to round
 * @param {Object} options - conversion options
 *
 * @return {number} - rounded quantity
 */
const roundQuantity = (quantity, options) => {
    //round to closest step multiple
    //or
    //round up to closest step multiple if number typed is exactly between StepQty
    // step 1.   4.5 -> 5    4.5/1 -> round(4.5) -> 5*1
    // step 3.   11  -> 12   11/3 -> round(3.66) -> 4*3
    // step 1.6. 5   -> 4.8  5/1.6 -> round(3.125) -> 3*1.6
    // step 1.7. 5.5 -> 5.1  5.5/1.7 -> round(3.235) -> 3*1.7
    let roundedQuantity;
    let division;

    division = reduceTail(quantity / options.stepQuantity);
    roundedQuantity = Math.round(division) * options.stepQuantity;

    return reduceTail(roundedQuantity);
};

/**
 * Removes extra digits after comma.
 * 3.2+1.6 = 4.80000000001 -> 4.8
 * @param {number} quantity - quantity to reduce
 *
 * @return {number} - quantity
 */
const reduceTail = quantity => {
    return Math.round((quantity)*100)/100;
};

/**
 *
 * @param {string} value
 * @returns String
 */
const removeCurrencyFromStringAndConverToNumber = (value) => {
    if (!value) {
        return "0,00";
    }
    var regexReplaced = value;
    if (value.toString().indexOf("€") != -1) {
        regexReplaced = value.replace(/€/g, "");
    }

    regexReplaced = regexReplaced.replace(",", ".");
    return parseFloat(regexReplaced).toFixed(2).replace(".", ",");
};

module.exports = {
    primaryToSecondary: primaryToSecondary,
    secondaryToPrimary: secondaryToPrimary,
    roundQuantity: roundQuantity,
    reduceTail: reduceTail,
    removeCurrencyFromStringAndConverToNumber: removeCurrencyFromStringAndConverToNumber
};
